import { useEffect, useState } from "react";
import { useParams } from "react-router";

import style from "./AdminDashBoard.module.css";

import AdminNavBar from "../NavBar/AdminNavBar";
import ProjectCard from "../../../components/ProjectCard/ProjectCard";
import TaskCard from "../../../components/TaskCard/TaskCard";
import ViewAllButton from "../../../components/buttons/viewAllButton/viewAllButton";

import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import TaskAltIcon from "@mui/icons-material/TaskAlt";

import ProfileCard from "../../../components/EmployeeProfileCard/profileCard";
import MiniTaskCard from "../../../components/miniTaskCard/miniTaskCard";
import RevenueCard from "../../../components/revenueCard/revenueCard";
import MiniCardLoader from "../../../components/LoadingComponents/miniCardLoader/miniCardLoader";
import ProfileLoader from "../../../components/LoadingComponents/ProfileLoader/ProfileLoader";
import RevenueLoader from "../../../components/LoadingComponents/RevenueLoader/RevenueLoader";
import ProjectCardLoader from "../../../components/LoadingComponents/ProjectCardLoader/ProjectCardLoader";
import TaskCardLoader from "../../../components/LoadingComponents/TaskCardLoader/TaskCardLoader";

export default function AdminDashBoard() {

    const [admin, setAdmin] = useState({});
    const [employeeList, setEmployeeList] = useState([]);
    const [payroll, setPayroll] = useState({});
    const [projects, setProjects] = useState([]);
    const [tasks, setTasks] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    const { employeeId } = useParams();
    const token = localStorage.getItem("token");
    const apiurl = process.env.REACT_APP_SERVER_URL;

    if (!apiurl) console.error("❌ REACT_APP_SERVER_URL is missing in your .env file");

    // Fetch Condition using the setter and endpoints
    const fetchData = async (endpoint, setter) => {
        try {
            const url = `${apiurl}${endpoint}`;

            const res = await fetch(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!res.ok) {
                setLoading(true)
                const text = await res.text();
                throw new Error(`HTTP error! Status: ${res.status}, Response: ${text}`);
            }

            const data = await res.json();
            setLoading(false);
            setter(data || {});

        } catch (err) {
            setError(`Failed to fetch`);
        }
    };

    // fetching the employees,users,projects, tasks, payroll
    useEffect(() => {

        if (!apiurl || !employeeId) return;

        fetchData(`/admin-dashboard/${employeeId}`, (data) => setAdmin(data.user || {}));
        fetchData("/users", (data) => setEmployeeList(data.users || []));
        fetchData("/projects/all-projects", (data) => setProjects(data.projects || []));
        fetchData("/tasks/all-tasks", (data) => setTasks(Array.isArray(data.tasks) ? data.tasks : []));
        fetchData(`/payroll/${employeeId}`, (data) => setPayroll(data.payroll || {}));

    });

    return (
        <>
            <AdminNavBar />
            <div style={{ display: 'none' }}>
                {employeeList ? <p>yes</p> : <p>no</p>}
            </div>
            <div className={style.Dashboard}>
                <div className="container mb-3 mb-lg-5 pb-lg-5">

                    {/* error component */}
                    {error && <p className="text-danger">{error}</p>}

                    {/* Admin details */}
                    <div className={`${style.userDetails} ps-3 pt-lg-3  `}>
                        <h6>Hi <b> {admin?.firstName || "User"}</b></h6>
                        <p className={style.welcomeMsg}>Welcome to Your Dashboard</p>
                    </div>

                    {/* row layout for profile loader and profile card */}
                    <div className="row">
                        <div className="col-12 col-sm-12  mb-3 col-md-5 col-lg-5">
                            {loading ?
                                <>
                                    <ProfileLoader />
                                </>
                                :
                                <>
                                    <ProfileCard
                                        firstName={admin?.firstName}
                                        lastName={admin?.lastName}
                                        position={admin?.position}
                                        email={admin?.email}
                                        phone={admin?.phonePrimary}
                                        imgAlt={admin?.firstName ? admin?.firstName.charAt(0) : "o"}
                                    />
                                </>
                            }
                        </div>
                        <div className="col-12 col-md-3 col-lg-3">
                            <div className="row">
                                <div className="col-12 mb-3 mb-lg-2">
                                    {loading ?
                                        <>
                                            <MiniCardLoader />
                                        </>
                                        :
                                        <>
                                            <MiniTaskCard
                                                icon={<TaskAltIcon sx={{ fontSize: 30 }} />}
                                                length={projects ? projects?.length : 0}
                                                color={'#008000'}
                                                backgroundColor={'#3DD1781F'}
                                                title="Total Projects"
                                            />
                                        </>
                                    }

                                </div>
                                <div className="col-12 mt-md-2 mb-3 mt-lg-4">
                                    {loading ?
                                        <>
                                            <MiniCardLoader />
                                        </>
                                        :
                                        <>
                                            <MiniTaskCard
                                                icon={<DriveFileRenameOutlineIcon
                                                    sx={{ fontSize: 35 }} />}
                                                length={tasks.length}
                                                color={'#0000FF'}
                                                backgroundColor={'#17a4ba1f'}
                                                title="Total Tasks"
                                            />
                                        </>
                                    }
                                </div>
                            </div>
                        </div>

                        {/* Revenue card section start */}
                        <div className="col-12  col-md-4 col-lg-4">
                            {loading ?
                                <>
                                    <RevenueLoader />
                                </>
                                :
                                <>
                                    <RevenueCard
                                        revenueAmount={payroll?.baseSalary}
                                        successIcon={<TrendingUpIcon sx={{ fontSize: 35, color: "green" }} />}
                                        FailureIcon={<TrendingDownIcon sx={{ fontSize: 35, color: "red" }} />}
                                    />
                                </>
                            }

                        </div>
                    </div>

                    {/* Row layout for project loader card and Recent Project card  */}
                    <div className="row">
                        <div className="d-flex justify-content-between align-items-center  mt-3">
                            <p className={`${style.tabTitle} mb-0 ms-3`}>Recent Projects</p>
                            <ViewAllButton name="view all" path={`/admin-dashboard/${employeeId}/all-projects`} />
                        </div>
                        {loading ?
                            <>
                                <div className="col-lg-4">
                                    <ProjectCardLoader />
                                </div>
                                <div className="col-lg-4">
                                    <ProjectCardLoader />
                                </div>
                                <div className="col-lg-4">
                                    <ProjectCardLoader />
                                </div>
                            </>
                            :
                            <>
                                {projects.slice(0, 3).map((project, idx) => (
                                    <div className="col-lg-4 " key={idx}>
                                        <ProjectCard
                                            title={project.title}
                                            team={project.team}
                                            description={project.description}
                                            percentage={90}
                                            link={`/admin-dashboard/${employeeId}/projects/${project._id}`}
                                        />
                                    </div>
                                ))}
                            </>}
                    </div>

                    {/* Row layout for Tasks loadder card and recent tasks card */}
                    <div className="row mt-2">
                        <div className="d-flex justify-content-between align-items-center mb-3 mt-3">
                            <p className={`${style.tabTitle} mb-0 ms-2`}>Tasks</p>
                            <ViewAllButton name="view all" path={`/admin-dashboard/${employeeId}/all-tasks`} />
                        </div>
                        {loading ?
                            <>
                                <TaskCardLoader />
                                <TaskCardLoader />
                                <TaskCardLoader />
                            </>
                            :
                            <>
                                {tasks.slice(0, 3).map((task, index) => (
                                    <div className="mb-4 mt-1" key={index}>
                                        <TaskCard
                                            title={task.title}
                                            finishingDate={task.finishingDate}
                                            finishingTime={task.finishingTime}
                                            priority={task.priority}
                                            assignedFor={Array.isArray(task.employeeId) ? task.employeeId.join(", ") : ""}
                                            assignedBy={task.assignedBy}
                                        />
                                    </div>
                                ))}
                            </>
                        }
                    </div>
                </div>
            </div >
        </>
    );
}
